import { useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { BreadCrumbs } from '../../Layout/Header/BreadCrumbs';

import { CategoryCreate } from './CategoryCreate';

import { AddRecord } from '@components/ActionButtons';
import { BoxHeaderTitle } from '@components/Box';
import { BoxBodyContainer } from '@components/Box/BoxBodyContainer';
import { BreadcrumbsContainer } from '@components/BreadcrumbsContainer';
import { GridHeaderMenuTitle } from '@components/HeaderTitle';
import { Modal } from '@components/Modal';
import { routes } from '@config/routes';

export const Category: React.FC = () => {
  const [showCreateCategory, setShowCreateCategory] = useState(false);
  const refreshListRef = useRef<(() => void) | null>(null);

  const captureRefreshFunction = (refreshFn: () => void) => {
    refreshListRef.current = refreshFn;
  };

  const refreshData = () => {
    if (refreshListRef.current) {
      refreshListRef.current();
    }
  };

  const baseBreadCrumbs = [{ link: 'Inventory', to: '' }];

  const isOnCustomersPage = location.pathname === routes.CATEGORIES;

  const breadCrumbLinks = isOnCustomersPage
    ? baseBreadCrumbs
    : [...baseBreadCrumbs, { link: 'Category', to: routes.CATEGORIES }];

  return (
    <>
      <div className="p-4 space-y-4">
        <BreadcrumbsContainer>
          <div className="text-sm font-semibold text-gray-500">Inventory</div>
          <div>
            <BreadCrumbs links={breadCrumbLinks} />
          </div>
        </BreadcrumbsContainer>

        <div>
          <div className="flex justify-between items-center space-x-5">
            <BoxHeaderTitle>
              <GridHeaderMenuTitle>
                <div className="lg:text-2xl md:text-xl text-md lg:font-black md:font-black font-bold">
                  Category
                </div>
              </GridHeaderMenuTitle>
            </BoxHeaderTitle>

            <div className="">
              <div className="flex flex-row space-x-1">
                <AddRecord
                  label="New Category"
                  onClick={() => setShowCreateCategory(true)}
                />
              </div>
              {showCreateCategory && (
                <>
                  <Modal show={true}>
                    <CategoryCreate
                      onClose={(refreshGrid?: boolean) => {
                        setShowCreateCategory(false);
                        if (refreshGrid) {
                          refreshData();
                        }
                      }}
                    />
                  </Modal>
                </>
              )}
            </div>
          </div>

          <div className="p-4 bg-white rounded-b-xl rounded-tr-xl">
            <BoxBodyContainer>
              <Outlet context={{ captureRefreshFunction }} />
            </BoxBodyContainer>
          </div>
        </div>
      </div>
    </>
  );
};
